import type { Role, RoleWriteInput } from "../domain";
import type { RoleDto, RoleWriteDto } from "./rolesDtos";

export function roleFromDto(dto: RoleDto): Role {
  return {
    ...dto,
    permissions: [...dto.permissions],
  };
}

export function roleToDto(input: RoleWriteInput): RoleWriteDto {
  return {
    nameEn: input.nameEn,
    nameAr: input.nameAr,
    isActive: input.isActive,
    permissions: [...input.permissions],
  };
}
